"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Creates a high score list with the given ScoreInfo type.
 * NOTE: ScoreInfo must be serializable to JSON using JSON.stringify.
 */
class KHHighScores {
    constructor(comparator, maxItems, defaultScores) {
        this.comparator = comparator;
        this.maxItems = maxItems;
        this.scores = defaultScores;
        this.defaultScores = [...defaultScores];
    }
    setManager(manager) {
        this.manager = manager;
    }
    toJSON() {
        return this.scores;
    }
    fromJSON(json) {
        this.scores = json;
        if (!Array.isArray(this.scores)) {
            this.scores = [...this.defaultScores];
        }
        this.sort(this.scores);
    }
    sort(scores) {
        scores.sort((a, b) => this.comparator(a.score, b.score));
    }
    clear() {
        this.scores = [];
    }
    /**
     * Gets the high scores. Modifying this WILL modify
     * the high score table. Changes to this must be registered
     * using save or they will not be persisted.
     */
    get() {
        return this.scores;
    }
    /**
     * Adds a score to the list, trimming the list if that would
     * bring it above the max items.
     * @param name Name to attach to the score.
     * @param score The score itself.
     * @param saveAfter Whether the high scores should be saved after writing.
     */
    addScore(name, score, saveAfter = true) {
        this.scores.push({ name, score });
        this.sort(this.scores);
        this.scores.length = Math.min(this.maxItems, this.scores.length);
        if (saveAfter)
            this.save();
    }
    /**
     * Returns the rank that the given score would get if
     * it was added to the list. Does not modify the list
     * itself.
     */
    newScoreRank(score) {
        let scoreCopy = [...this.scores];
        const val = { name: '', score };
        scoreCopy.push(val);
        this.sort(scoreCopy);
        return scoreCopy.indexOf(val);
    }
    /**
     * Determines whether or not the passed score would
     * appear in the high score list.
     */
    wouldBeHighScore(score) {
        return this.newScoreRank(score) < this.maxItems;
    }
    save() {
        this.manager.save(this);
    }
}
KHHighScores.NumberDescendingComparator = (a, b) => b - a;
KHHighScores.NumberAscendingComparator = (a, b) => a - b;
exports.default = KHHighScores;
